export default {
  create: {
    title: 'Agregar',
    subtitle: 'Juegos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Juego',
    button: {
      add: 'Nuevo juego',
    },
  },
  list: {
    title: 'Walls',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  card: {
    title: 'Walls',
    actions: 'Acciones',
  },
  table: {
    title: 'Juegos activos',
    searchPlaceholder: 'Buscar por algo...',
  },
  form: {
    name: {
      label: 'Nombre:',
      placeholder: 'Ej: Walls Nivel 1',
      invalid: 'El nombre es obligatorio',
    },
    showAnswer: {
      label: 'Mostrar respuesta',
    },
    colored: {
      label: 'Colorido',
    },
    columns: {
      label: 'Columnas:',
    },
    rows: {
      label: 'Filas:',
    },
    level: {
      label: 'Nivel:',
      placeholder: 'Seleccione el nivel...',
      invalid: 'El nivel es obligatorio',
      tooltip:
        'El nivel influye en la generación del juego, pero puede cambiarlo libremente sin necesidad de generar uno nuevo.',
    },
  },
  button: {
    generate: 'Generar juego',
  },
  sidebar: {
    exportHint: 'Debe guardar antes de exportar.',
    defaultFileName: 'walls',
  },
  alert: {
    generated: '¡Puzzle generado con éxito!',
    bestPuzzle: 'Mejor puzzle: {junk} celda(s) de basura.',
    generateFailed: 'Error en la generación.',
    workerCritical: 'Error interno en los workers.',
    gameSaved: '¡Juego guardado con éxito!',
    workerErrors: {
      noValidPuzzle: 'No fue posible generar ningún puzzle válido.',
    },
  },
};
